import { api as $axios } from '@/helpers/interceptors'
import {
  PRODUCT_QUOTA_TIME,
  PRODUCT_QUOTA_UPLOAD,
  PRODUCT_QUOTA_EXPORT,
} from '@/constants/path'
import { meta } from '@/config/pagination'
import snakeCaseKeys from 'snakecase-keys'

const setUnLoading = (commit, status = false) => {
  commit('SET_STATE', {
    key: 'isLoading',
    value: status,
  })
}
const initFilter = {
  page: 1,
  perPage: 15,
}
const state = () => ({
  loadingUploadFile: false,
  loadingDownloadFile: false,
  data: [],
  productName: [],
  meta,
  isError: false,
  isLoading: false,
  form: {
    productId: null,
    date: null,
    quotaLimit: null,
    conditionCheckout: null,
  },
  filter: initFilter,
  selectedProductName: null,
  deepData: [],
  error: null,
})

// getters
const getters = {}

// actions
const actions = {
  async getProductQuotaList({ commit }, params) {
    setUnLoading(commit, true)
    try {
      const res = await $axios(
        `${PRODUCT_QUOTA_TIME}`,
        'get',
        snakeCaseKeys({ params }),
      )
      //   commit('SET_FORM', res?.data?.data?.branches?.data)

      const deepData = res?.data?.data
      const productName = []

      for (let i = 0; i < deepData.length; i++) {
        productName.push(deepData[i].name)
      }

      commit('SET_STATE', {
        key: 'data',
        value: deepData.find((x) => x.name === productName?.[0]),
      })

      commit('SET_STATE', {
        key: 'deepData',
        value: deepData,
      })

      commit('SET_STATE', {
        key: 'selectedProductName',
        value: productName?.[0],
      })

      commit('SET_STATE', {
        key: 'productName',
        value: productName,
      })

      commit('SET_STATE', {
        key: 'meta',
        value: res?.data?.meta,
      })

      setUnLoading(commit)
    } catch (error) {
      commit('SET_STATE', {
        key: 'meta',
        value: meta,
      })
      commit('SET_STATE', {
        key: 'data',
        value: [],
      })
      setUnLoading(commit)
    }
  },

  // eslint-disable-next-line no-empty-pattern
  async getProductQuotaById({}, params) {
    try {
      const res = await $axios(
        `${PRODUCT_QUOTA_TIME}`,
        'get',
        snakeCaseKeys({ params }),
      )
      const data =
        res?.data?.data?.[0]?.size?.[0]?.productList?.[0]?.date?.map(
          (x) => ({ ...x, quotaLimit: 0 }),
        )
      return data
    } catch (error) {
      return []
    }
  },
  setDataSort({ commit }, data) {
    commit('SET_STATE', {
      key: 'data',
      value: data,
    })
  },
  async setForm({ commit }, id) {
    setUnLoading(commit, true)
    try {
      const res = await $axios(`${PRODUCT_QUOTA_TIME}/${id}`, 'get')
      commit('SET_STATE', {
        key: 'form',
        value: res?.data?.data,
      })
      setUnLoading(commit)
      return res?.data?.data
    } catch (error) {
      setUnLoading(commit)
    }
  },
  async createQuota({ commit }, form) {
    const { data } = await $axios(PRODUCT_QUOTA_TIME, 'post', form)
    commit('SET_STATE', {
      key: 'error',
      value: data?.message,
    })
  },

  async deleteTime(_, id) {
    await $axios(`${PRODUCT_QUOTA_TIME}/${id}`, 'delete')
  },

  /**
   * ดาวน์โหลด template/ข้อมูลโควต้าเป็น .xlsx (14 คอลัมน์)
   * ไฟล์ที่ได้อัปกลับเข้า uploadExcel ได้ทันที
   * ไม่ catch เอาไว้เอง เพราะ error ของ responseType blob เป็น Blob ที่ข้างในเป็น JSON
   * ฝั่ง view ต้องแกะข้อความเอง (interceptors toast ไม่ออก)
   */
  async exportExcel({ commit }, { campaignId }) {
    commit('SET_STATE', {
      key: 'loadingDownloadFile',
      value: true,
    })
    try {
      const { data } = await $axios(PRODUCT_QUOTA_EXPORT, 'getblob', {
        params: { campaign_id: campaignId },
      })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(data)
      link.download = `product-quota-time-${campaignId}.xlsx`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(link.href)
    } finally {
      commit('SET_STATE', {
        key: 'loadingDownloadFile',
        value: false,
      })
    }
  },

  async uploadExcel({ commit }, data) {
    try {
      commit('SET_STATE', {
        key: 'loadingUploadFile',
        value: true,
      })
      await $axios(PRODUCT_QUOTA_UPLOAD, 'post', data)
      commit('SET_STATE', {
        key: 'loadingUploadFile',
        value: false,
      })
    } catch (error) {
      commit('SET_STATE', {
        key: 'loadingUploadFile',
        value: false,
      })
    }
  },
}

// mutations
const mutations = {
  SET_STATE(state, ops) {
    state[ops.key] = ops.value
  },

  SET_FORM(state, value) {
    value.forEach((item) => {
      item.isBranchDeposit = Boolean(Number(item.isBranchDeposit))
    })
    state.data = value
  },

  SET_PRODUCT_DATA(state, value) {
    const index = state.deepData.findIndex((x) => x.name === value)
    state.data = state.deepData[index]
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
